// Utility for filtering arrays by JSON field in a property
// Handles JSON parse errors gracefully

/**
 * Filters an array of objects by a JSON field in a given property.
 * @param {Array} data - The array to filter.
 * @param {string} property - The property name containing the JSON string.
 * @param {Object} options - Filtering options.
 *   - {string} field: The field in the parsed JSON to check (e.g., 'status', 'followup').
 *   - {string|string[]} value: The value(s) to match (for equality or inclusion).
 *   - {boolean} [isTruthy]: If true, checks if the field is truthy (for boolean fields).
 * @returns {Array} Filtered array.
 */
export function filterByJsonField(data, property, { field, value, isTruthy = false }) {
  return data.filter((item) => {
    if (!item[property]) return false;
    let parsed;
    try {
      parsed = JSON.parse(item[property]);
    } catch (e) {
      console.error('Invalid JSON in', property, e, item[property]);
      return false;
    }
    if (isTruthy) {
      return !!parsed[field];
    }
    if (Array.isArray(value)) {
      return value.includes(parsed[field]);
    }
    return parsed[field] === value;
  });
}
